// youtubeShorts.js
// Use any YouTube URL format:
//   https://www.youtube.com/shorts/VIDEO_ID
//   https://youtu.be/VIDEO_ID
//   https://www.youtube.com/watch?v=VIDEO_ID
// Component auto-extracts the video ID.

const youtubeShorts = {
  section_title: 'Property Shorts',
  section_subtitle: 'Quick property tours — swipe through our latest picks.',
  yt_channel_url: 'https://www.youtube.com/@PropertiesInfinite',

  shorts: [
    {
      id: 1,
      short_url: 'https://youtube.com/shorts/VuJ-emuSt6s?si=GUnPc_bQpDJzGCsU',
      title: 'Luxury Villa Tour — Anna Nagar',
      location: 'Chennai',
    },
    {
      id: 2,
      short_url: 'https://youtube.com/shorts/-9w0nE_JfYM?si=jko7_IkervdJ26Fi',
      title: '3BHK Apartment Walkthrough',
      location: 'Bengaluru',
    },
    {
      id: 3,
      short_url: 'https://youtube.com/shorts/YCiPcurYL8w?si=cJ_zytw2A55SJqCS',
      title: 'Plot Land View — RS Puram',
      location: 'Coimbatore',
    },
    {
      id: 4,
      short_url: 'https://youtube.com/shorts/oQixxuKMpo0?si=alFM_NUGmv300sws',
      title: 'Commercial Office Space',
      location: 'Hyderabad',
    },
    {
      id: 5,
      short_url: 'https://youtube.com/shorts/n8TNg8NT5NI?si=Y2v0Pf0WwGd625Kw',
      title: 'Beachside Villa Tour',
      location: 'Kochi',
    },
    {
      id: 6,
      short_url: 'https://www.youtube.com/shorts/OPf0YbXqDm0',
      title: 'Budget Apartment — 2BHK',
      location: 'Madurai',
    },
    {
      id: 7,
      short_url: 'https://youtube.com/shorts/2_xVxw03D4w?si=qVB24zinTMu9sIgz',
      title: 'Penthouse View — Juhu',
      location: 'Mumbai',
    },
    {
      id: 8,
      short_url: 'https://youtube.com/shorts/L9NafgN6WIo?si=jMzlN7NuJgeDwJjJ',
      title: 'Gated Community Tour',
      location: 'Pune',
    },
    {
      id: 9,
      short_url: 'https://youtube.com/shorts/F7OB_0Wu7uA?si=Y_yXu8hrMQJvC56l',
      title: 'Farmhouse Property',
      location: 'Mysuru',
    },
    {
      id: 10,
      short_url: 'https://youtube.com/shorts/1xvfgY5QIM8?si=9GlKrOTE_I7fhJNs',
      title: 'Studio Apartment — City Centre',
      location: 'Trichy',
    },
  ],
};

export default youtubeShorts;